/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { types } from "./actions";

const initialState = {
  list: [],
  data: {},
  summary: {},
  error: null,
  loading: false,
  loaded: false,
  rateData: {},
  stdRateData: {},
  rateError: null,
  successResponse: null,
  rateSuccessResponse: null,
  adjustCreditSuccessResponse: null,
  adjustCreditErrorResponse: null,
  dateRange: {},
  thisMonthDateRange: {},
  errorResponse: null,
  isLoading: false,
  isLoaded: false,
  standardRate: null,
  isCreateLoading: false,
  billLoading: false,
  billLoaded: false,
  preBillLoading: false,
  preBillLoaded: false,
  isCreateLoaded: false,
  customRate: null,
  mediatailorDataUsage: [],
  mediatailorDataUsageError: null,
  mediatailorDataUsageLoading: false,
  mediatailorDataUsageLoaded: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_CURRENT_BILL: {
      return {
        ...state,
        billLoading: true,
        billLoaded: false,
      };
    }
    case types.FETCH_CURRENT_BILL_SUCCESS: {
      return {
        ...state,
        billLoading: false,
        billLoaded: true,
        data: action.payload,
      };
    }
    case types.FETCH_CURRENT_BILL_FAILED: {
      return {
        ...state,
        billLoading: false,
        billLoaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_COMPANY_EVOLUTION_BREAK: {
      return {
        ...state,
        loading: true,
        loaded: false,

        thisMonthDateRange: {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate,
        },
      };
    }
    case types.FETCH_COMPANY_EVOLUTION_BREAK_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
      };
    }
    case types.FETCH_COMPANY_EVOLUTION_BREAK_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_COUNT_SUMMARY_SUCCESS: {
      /* istanbul ignore next */
      return {
        ...state,
        summaryLoading: false,
        summaryLoaded: true,
        summary: action.payload,
      };
    }
    case types.FETCH_COUNT_SUMMARY: {
      /* istanbul ignore next */
      return {
        ...state,
        summaryLoading: true,
        summaryLoaded: false,
        // summary: {}
      };
    }
    case types.FETCH_COUNT_SUMMARY_FAILED: {
      /* istanbul ignore next */
      return {
        ...state,
        summaryLoading: false,
        summaryLoaded: true,
        summaryError: action.payload,
      };
    }
    case types.FETCH_COMPANY_PREV_EVOLUTION_BREAK: {
      return {
        ...state,
        preBillLoading: true,
        preBillLoaded: false,
      };
    }
    case types.FETCH_COMPANY_PREV_EVOLUTION_BREAK_SUCCESS: {
      return {
        ...state,
        preBillLoading: false,
        preBillLoaded: true,
        ...action.payload,
      };
    }
    case types.FETCH_COMPANY_PREV_EVOLUTION_BREAK_FAILED: {
      return {
        ...state,
        preBillLoading: false,
        preBillLoaded: true,

        error: action.payload,
      };
    }

    case types.FETCH_TOTAL_BREAK: {
      return {
        ...state,
        loading: true,
        loaded: false,
        dateRange: {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate,
        },
      };
    }
    case types.FETCH_TOTAL_BREAK_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        total: {
          ...state.total,
          ...action.payload,
        },
      };
    }
    case types.FETCH_TOTAL_BREAK_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_ALL_RATES: {
      return {
        ...state,
        loading: true,
        loaded: false,
        adjustCreditErrorResponse: null,
      };
    }
    case types.FETCH_ALL_RATES_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        rateData: action.payload,
      };
    }
    case types.FETCH_ALL_RATES_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        rateError: action.payload,
      };
    }
    case types.FETCH_ALL_STANDARD_RATES: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.FETCH_ALL_STANDARD_RATES_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        stdRateData: action.payload,
      };
    }
    case types.FETCH_ALL_STANDARD_RATES_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        rateError: action.payload,
      };
    }
    case types.SET_RATE: {
      return {
        ...state,
        loading: true,
        loaded: false,
        rateSuccessResponse: null,
        rateError: null,
      };
    }
    case types.SET_RATE_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        rateSuccessResponse: action.payload,
        rateError: null,
      };
    }
    case types.SET_RATE_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        rateError: action.payload,
      };
    }
    case types.SET_STANDARD_RATE: {
      return {
        ...state,
        loading: true,
        loaded: false,
        rateSuccessResponse: null,
        rateError: null,
      };
    }
    case types.SET_STANDARD_RATE_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        rateSuccessResponse: action.payload,
      };
    }
    case types.SET_STANDARD_RATE_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        rateError: action.payload,
      };
    }
    case types.UPDATE_CUSTOM_RATE: {
      return {
        ...state,
        loading: true,
        loaded: false,
        rateSuccessResponse: null,
        rateError: null,
      };
    }
    case types.UPDATE_CUSTOM_RATE_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        rateSuccessResponse: action.payload,
        rateError: null,
      };
    }
    case types.UPDATE_CUSTOM_RATE_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        rateError: action.payload,
      };
    }
    case types.UPDATE_STANDARD_RATE: {
      return {
        ...state,
        loading: true,
        loaded: false,
        rateSuccessResponse: null,
        rateError: null,
      };
    }
    case types.UPDATE_STANDARD_RATE_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        rateError: null,
        rateSuccessResponse: action.payload,
      };
    }
    case types.UPDATE_STANDARD_RATE_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        rateError: action.payload,
      };
    }
    case types.FETCH_CREDIT_HISTORY: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.FETCH_CREDIT_HISTORY_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        rateError: null,
        creditHistory: action.payload,
      };
    }
    case types.FETCH_CREDIT_HISTORY_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        rateError: action.payload,
      };
    }
    case types.FETCH_BILLING_HISTORY: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.FETCH_BILLING_HISTORY_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        rateError: null,
        billingHistory: action.payload,
      };
    }
    case types.FETCH_BILLING_HISTORY_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        rateError: action.payload,
      };
    }
    case types.ADJUST_CREDIT: {
      return {
        ...state,
        loading: true,
        loaded: false,
        adjustCreditSuccessResponse: null,
        errorResponse: null,
        adjustCreditErrorResponse: null,
      };
    }
    case types.ADJUST_CREDIT_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        adjustCreditSuccessResponse: action.payload,
        adjustCreditErrorResponse: null,
      };
    }
    case types.ADJUST_CREDIT_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        adjustCreditErrorResponse: action.payload,
      };
    }
    case types.DOWNLOAD_INVOICE: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        downloadInvoiceSuccessResponse: null,
        errorResponse: null,
        downloadInvoiceErrorResponse: {},
      };
    }
    case types.DOWNLOAD_INVOICE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        downloadInvoiceSuccessResponse: action.payload,
        downloadInvoiceErrorResponse: {},
      };
    }
    case types.DOWNLOAD_INVOICE_FAILED: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        downloadInvoiceErrorResponse: action.payload,
      };
    }
    case types.FETCH_STANDARD_RATES_LIST: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.FETCH_STANDARD_RATES_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.payload,
      };
    }
    case types.FETCH_STANDARD_RATES_LIST_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.CLEAR_STANDARD_RATES_LIST: {
      return {
        ...state,
        loading: false,
        loaded: false,
        list: [],
      };
    }
    case types.LOAD_MORE_STANDARD_RATES_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          result: [...state.list.result, ...action.payload.result],
        },
        isLoading: false,
      };
    case types.LOAD_MORE_STANDARD_RATES_FAILED:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    case types.FETCH_A_STANDARD_RATES: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    }
    case types.FETCH_A_STANDARD_RATES_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        standardRate: action.payload,
      };
    }
    case types.FETCH_A_STANDARD_RATES_FAILED: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case types.CLEAR_A_STANDARD_RATES: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        standardRate: null,
        successResponse: null,
      };
    }
    case types.DELETE_STANDARD_RATE: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    }
    case types.DELETE_STANDARD_RATE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        successResponse: action.payload,
      };
    }
    case types.DELETE_STANDARD_RATE_FAILED: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_CUSTOM_RATES_LIST: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.FETCH_CUSTOM_RATES_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.payload,
      };
    }
    case types.FETCH_CUSTOM_RATES_LIST_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.LOAD_MORE_CUSTOM_RATES_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          result: [...state.list.result, ...action.payload.result],
        },
        isLoading: false,
      };
    case types.LOAD_MORE_CUSTOM_RATES_FAILED:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    case types.CLEAR_CUSTOM_RATES_LIST: {
      return {
        ...state,
        loading: false,
        loaded: false,
        list: [],
      };
    }
    case types.CREATE_STANDARD_RATE: {
      return {
        ...state,
        isCreateLoading: true,
        isCreateLoaded: false,
        rateSuccessResponse: null,
        rateError: null,
      };
    }
    case types.CREATE_STANDARD_RATE_SUCCESS: {
      return {
        ...state,
        isCreateLoading: false,
        isCreateLoaded: true,
        rateSuccessResponse: action.payload,
      };
    }
    case types.CREATE_STANDARD_RATE_FAILED: {
      return {
        ...state,
        isCreateLoading: false,
        isCreateLoaded: true,
        rateError: action.payload,
      };
    }
    case types.CLEAR_CREATE_RATE_CARD: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        rateSuccessResponse: null,
        rateError: null,
      };
    }
    case types.FETCH_A_CUSTOM_RATES: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    }
    case types.FETCH_A_CUSTOM_RATES_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        customRate: action.payload,
      };
    }
    case types.FETCH_A_CUSTOM_RATES_FAILED: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case types.CREATE_CUSTOM_RATE: {
      return {
        ...state,
        isCreateLoading: true,
        isCreateLoaded: false,
        rateSuccessResponse: null,
        rateError: null,
      };
    }
    case types.CREATE_CUSTOM_RATE_SUCCESS: {
      return {
        ...state,
        isCreateLoading: false,
        isCreateLoaded: true,
        rateSuccessResponse: action.payload,
      };
    }
    case types.CREATE_CUSTOM_RATE_FAILED: {
      return {
        ...state,
        isCreateLoading: false,
        isCreateLoaded: true,
        rateError: action.payload,
      };
    }
    case types.FETCH_CURRENT_STANDARD_RATE: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    }
    case types.FETCH_CURRENT_STANDARD_RATE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        currentStandardRate: action.payload,
      };
    }
    case types.FETCH_CURRENT_STANDARD_RATE_FAILED: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case types.CLEAR_A_CUSTOM_RATE: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        customRate: null,
        successResponse: null,
      };
    }
    case types.DELETE_CUSTOM_RATE: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    }
    case types.DELETE_CUSTOM_RATE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        successResponse: action.payload,
      };
    }
    case types.DELETE_CUSTOM_RATE_FAILED: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_A_CUSTOM_RATE_STATUS: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    }
    case types.FETCH_A_CUSTOM_RATE_STATUS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        customRate: action.payload,
      };
    }
    case types.FETCH_A_CUSTOM_RATE_STATUS_FAILED: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case types.CLEAR_CURRENT_STANDARD_RATE: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        currentStandardRate: null,
        error: null,
      };
    }
    case types.FETCH_A_STANDARD_RATE_STATUS: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    }
    case types.FETCH_A_STANDARD_RATE_STATUS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        standardRate: action.payload,
      };
    }
    case types.FETCH_A_STANDARD_RATE_STATUS_FAILED: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_MEDIATAILOR_DATA_USAGE: {
      return {
        ...state,
        mediatailorDataUsageLoading: true,
        mediatailorDataUsageLoaded: false,
      };
    }
    case types.FETCH_MEDIATAILOR_DATA_USAGE_SUCCESS: {
      return {
        ...state,
        mediatailorDataUsageLoading: false,
        mediatailorDataUsageLoaded: true,
        mediatailorDataUsage: action.payload,
        mediatailorDataUsageError: null,
      };
    }
    case types.FETCH_MEDIATAILOR_DATA_USAGE_FAILED: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        mediatailorDataUsage: [],
        mediatailorDataUsageError: action.payload,
        mediatailorDataUsageLoading: false,
        mediatailorDataUsageLoaded: true,
      };
    }
    case types.CLEAR_MEDIATAILOR_APP_SESSION: {
      return {
        ...state,
        mediatailorDataUsageLoading: false,
        mediatailorDataUsageLoaded: false,
        mediatailorDataUsage: [],
        mediatailorDataUsageError: null,
      };
    }
    default:
      return state;
  }
}
